
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/compress/[id]",
      function () {
        return require("private-next-pages/tools/compress/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/compress/[id]"])
      });
    }
  